import React from "react";
import "./styles.css";

function Services() {
    return(
    <section className="services" id="services">
    <h2 className="heading">Services</h2>
        <div className="services-container">
         <div className="service-box">
          <div className="service-info">
          <i class="fa-brands fa-react"></i>
           <h4>Full-Stack Website Development</h4>
           <p>Developing complete frontend and backend websites using React, Node.js, and Python frameworks.</p>
          </div>
        </div>
        <div className="service-box">
          <div className="service-info">
          <i class="fa-brands fa-node-js"></i>
           <h4>Custom Web Application Development</h4>
           <p>Building scalable, responsive web applications using MERN Stack and Python frameworks.</p>
          </div>
        </div>
        <div className="service-box">
          <div className="service-info">
           <i class="fa-brands fa-shopify"></i>
           <h4>E-commerce Store Development</h4>
           <p>Building online stores using platforms like Shopify, Wix, and WooCommerce.</p>
          </div>
        </div>
        
        </div>
        <div className="services-container services-container1">
         <div className="service-box">
          <div className="service-info">
          <i class="fa-brands fa-python"></i>
           <h4>Automation & Backend Scripting (Python)</h4>
           <p>Developing automation scripts and backend tools for workflows and data processing.</p>
          </div>
        </div>
        <div className="service-box">
          <div className="service-info">
          <i class="fa-brands fa-node"></i>
           <h4>REST API Development & Integration</h4>
           <p>Creating secure APIs and integrating third-party services and systems.</p>
          </div>
        </div>
        <div className="service-box">
          <div className="service-info">
           <span class="material-symbols-outlined">smart_toy</span>
           <h4>AI, LLM & ERP Solutions Development</h4>
           <p>Building AI automation tools, LLM-powered applications, ERP systems, and MVP prototypes for startups and businesses.</p>
          </div>
        </div>
        
        </div>
    </section>

    )
}

export default Services;